export default "__VITE_ASSET__C3Pcx9zL__"